import { render, staticRenderFns } from "./EditMetaData.vue?vue&type=template&id=1ed1e1b2&scoped=true"
import script from "./EditMetaData.vue?vue&type=script&lang=js"
export * from "./EditMetaData.vue?vue&type=script&lang=js"
import style0 from "./EditMetaData.vue?vue&type=style&index=0&id=1ed1e1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed1e1b2",
  null
  
)

export default component.exports